import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4 col-sm-6 mb-25" }
const _hoisted_3 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "flex-grow-1 ms-3" }
const _hoisted_7 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_8 = { class: "col-lg-4 col-sm-6 mb-25" }
const _hoisted_9 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "flex-grow-1 ms-3" }
const _hoisted_13 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_14 = { class: "col-lg-4 col-sm-6 mb-25" }
const _hoisted_15 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "flex-grow-1 ms-3" }
const _hoisted_19 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_22 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_23 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_24 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_25 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_26 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_27 = { class: "table align-middle mb-0" }
const _hoisted_28 = { class: "fw-medium" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "dropdown" }
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-folder text-primary",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.stats.totalDossiers), 1),
              _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers totaux", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-check text-success",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.stats.dossiersValides), 1),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers validés", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-time text-warning",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.stats.dossiersEnValidation), 1),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "En cours de validation", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Dossiers en Validation / Validés", -1)),
          _createVNode(_component_router_link, {
            to: "/transitaire-dossiers",
            class: "btn btn-outline-primary btn-sm"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Voir tous les dossiers ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ], -1)
              ]))]))
            : (_ctx.dossiers.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("p", { class: "text-muted" }, "Aucun dossier en validation ou validé", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("table", _hoisted_27, [
                    _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Référence BESC"),
                        _createElementVNode("th", null, "Destination"),
                        _createElementVNode("th", null, "Statut"),
                        _createElementVNode("th", null, "Date création"),
                        _createElementVNode("th", null, "Date validation"),
                        _createElementVNode("th", { class: "text-end" }, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dossiers, (dossier) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: dossier.id
                        }, [
                          _createElementVNode("td", _hoisted_28, _toDisplayString(dossier.refbesc), 1),
                          _createElementVNode("td", null, _toDisplayString(dossier.destination || '—'), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              innerHTML: _ctx.getStatusBadge(dossier.status)
                            }, null, 8, _hoisted_29)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.format_date(dossier.created_at)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.format_date(dossier.validated_at)), 1),
                          _createElementVNode("td", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _cache[12] || (_cache[12] = _createElementVNode("span", {
                                class: "badge text-white bg-primary fs-15 dropdown-toggle",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false",
                                style: {"cursor":"pointer"}
                              }, [
                                _createTextVNode(" Actions "),
                                _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_32, [
                                _createElementVNode("li", null, [
                                  (dossier.id)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: { name: 'ViewBesc', params: { id: dossier.id } },
                                        class: "dropdown-item d-flex align-items-center"
                                      }, {
                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                          _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Détails ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"]))
                                    : _createCommentVNode("", true)
                                ]),
                                (dossier.status === 'VALIDE')
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                      _createElementVNode("a", {
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.telechargerPDF(dossier.id)),
                                        class: "dropdown-item d-flex align-items-center"
                                      }, [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("i", { class: "flaticon-file-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Télécharger PDF ", -1)
                                      ]))], 8, _hoisted_34)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
        ])
      ])
    ])
  ]))
}